import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

const Textarea = ({
	className,
	...props
}: React.ComponentProps<'textarea'>) => {
	return (
		<textarea
			data-slot="textarea"
			className={cn(
				'focus-cosy border-input bg-control-glass text-foreground placeholder:text-muted-foreground aria-[invalid]:border-input-invalid text-body-sm md:text-body-xs flex min-h-20 w-full rounded-xl border px-3 py-2 disabled:cursor-not-allowed disabled:opacity-50',
				className,
			)}
			{...props}
		/>
	)
}

export { Textarea }
